<template>
	<div class="top">
		<div class="ul">
			<a href="https://mi-web.idfgm.com">加盟商登录</a>
			<!-- <a href="">用户登录</a> -->
			<!-- <a href="http://g.idfgm.com">供应商登录</a> -->
			<a href="">帮助中心</a>
			<a href="">联系我们</a>
			<!-- <el-dropdown>
			  <span class="el-dropdown-link">
				更多<i class="el-icon-arrow-down el-icon--right"></i>
			  </span>
			  <el-dropdown-menu slot="dropdown">
				<el-dropdown-item>更多</el-dropdown-item>
			  </el-dropdown-menu>
			</el-dropdown> -->
		</div>
	</div>
</template>

<script>
	export default {
	  name: 'Header',
	  props: {
	    msg: String
	  }
	}
</script>

<style scoped="scoped">
	.top {
		width: 60%;
		height: 37px;
		background: #F5F5F5;
		opacity: 1;
		position: sticky;
		top: 0;
		z-index: 999;
		padding: 0 20%;
	}
	.ul{
		height: 100%;
		display: flex;
		align-items: center;
		font-size: 14px;
		float: right;
	}
	.el-dropdown{
		color: #666666;
		padding: 0 5px;
	}
	.ul a{
		display: block;
		padding: 0 5px;
		border-right: 1px solid #CCCCCC;
		text-decoration: none;
		color: #666666;
	}
	@media screen and (max-width: 1600PX) {
	    .top{
			width: 80%;
			padding: 0 10%;
		}
	}
</style>
